module.exports = __webpack_public_path__ + "static/media/I'll Be There.758e2fea.jpg";